import { Card, Container, Grid, GridItem, Stack } from "@octopus-energy/coral/atoms"
import { useCoralConfig } from "@octopus-energy/coral/providers"
import CustomHead from "@/components/atoms/CustomHead"
import { Page } from "@/components/organisms"
import { PowerAnalysisForm } from "@/features/meterPowerAnalysis"
import { type SbMeterPowerAnalysisStory } from "../../../../types"
import { StoryblokBlokLooper } from "../../../StoryblokBlokLooper"

type MeterPowerAnalysisTemplateProps = {
    story: SbMeterPowerAnalysisStory
}

export function MeterPowerAnalysisTemplate({ story }: MeterPowerAnalysisTemplateProps) {
    const { headerHeight } = useCoralConfig()
    const { leftTopBlock, leftBottomBlock, bottomBlock, metaRobots, metadata } = story.content

    return (
        <>
            <CustomHead
                title={metadata?.title}
                description={metadata?.description}
                robots={metaRobots?.join(",")}
            />
            <Page>
                <Stack
                    flexDirection="column"
                    alignItems="center"
                    gap="xxxl"
                >
                    <Grid
                        gap={{ base: "xxxl", md: "md" }}
                        gridTemplateColumns={{ base: "100%", md: "1fr 1fr" }}
                    >
                        <GridItem gridRowStart={1}>
                            <StoryblokBlokLooper blocks={leftTopBlock} />
                        </GridItem>

                        <GridItem gridRowStart={{ base: 3, md: 2 }}>
                            <StoryblokBlokLooper blocks={leftBottomBlock} />
                        </GridItem>

                        <GridItem
                            gridRow={{ base: "span 1", md: "span 2" }}
                            gridRowStart={{ base: 2, md: 1 }}
                        >
                            <Container
                                top={headerHeight}
                                position="sticky"
                            >
                                <Card fullWidth>
                                    <PowerAnalysisForm />
                                </Card>
                            </Container>
                        </GridItem>
                    </Grid>
                    <Stack flexDirection="column">
                        <StoryblokBlokLooper blocks={bottomBlock} />
                    </Stack>
                </Stack>
            </Page>
        </>
    )
}

MeterPowerAnalysisTemplate.messages = [...PowerAnalysisForm.messages] as const
